/**
 * Display helpers for hour.project_activity (API may use snake_case or camelCase).
 * Legacy hour.activity (ActivityItem) should not be shown in the hours UI.
 */
export function projectActivityLine(pa) {
  if (!pa) return "";
  const label = pa.display_title ?? pa.displayTitle ?? pa.title;
  if (label) return label;
  if (pa.number != null && pa.number !== "") return String(pa.number);
  return "";
}

export function hourHasProjectActivity(hour) {
  if (!hour) return false;
  return hour.project_activity?.id != null || hour.project_activity_id != null;
}
